
$(document).ready(function(){
    
    
  // hide our element on page load
  $('#home-font-branding-fade-up').css('opacity', 0);
  $('#home-font-branding-fade-up').waypoint(function() {
      $('#home-font-branding-fade-up').addClass('fadeInUp animated');
      $('#home-font-branding-fade-up').css('opacity', 1);
  }, { offset: '100%' });
 
  
  // hide our element on page load
  $('#home-two-quarters-one').css('opacity', 0);
  $('#home-two-quarters-one').waypoint(function() {
      $('#home-two-quarters-one').addClass('fadeIn animated');
      $('#home-two-quarters-one').css('opacity', 1);
  }, { offset: '90%' });
  
  // hide our element on page load
  $('#home-pump-clips').css('opacity', 0);
  $('#home-pump-clips').waypoint(function() {
      $('#home-pump-clips').addClass('fadeInRight animated');
      $('#home-pump-clips').css('opacity', 1);
  }, { offset: '60%' });
  
    // hide our element on page load
  $('#home-lenses').css('opacity', 0);
  $('#home-lenses').waypoint(function() {
      $('#home-lenses').addClass('fadeInRight animated');
      $('#home-lenses').css('opacity', 1);
  }, { offset: '40%' });


  // hide our element on page load
  $('#home-two-quarters-two').css('opacity', 0);
  $('#home-two-quarters-two').waypoint(function() {
      $('#home-two-quarters-two').addClass('fadeIn animated');
      $('#home-two-quarters-two').css('opacity', 1);
  }, { offset: '80%' });
  
  // hide our element on page load
  $('#home-tap-handles').css('opacity', 0);
  $('#home-tap-handles').waypoint(function() {
      $('#home-tap-handles').addClass('fadeInUp animated');
      $('#home-tap-handles').css('opacity', 1);
  }, { offset: '40%' });

  // hide our element on page load
  $('#home-signs').css('opacity', 0);
  $('#home-signs').waypoint(function() {
      $('#home-signs').addClass('fadeInUp animated');
      $('#home-signs').css('opacity', 1);
  }, { offset: '60%' });
  


 
});